import MetricSeries from '../enums/MetricSeries'
import AnalysisType from '../enums/AnalysisType'
import * as measureTypeUtil from './measureTypeUtil'

export const getParentLabel = (measure) => {
  switch (measure) {
    case MetricSeries.POST_VIDEOS:
    case MetricSeries.POST_IMAGES:
    case MetricSeries.POST_OTHER:
      return measureTypeUtil.getLabel(MetricSeries.TOTAL_BUZZ_POST)
    case MetricSeries.POSITIVE_SENTIMENT:
    case MetricSeries.NEGATIVE_SENTIMENT:
      return measureTypeUtil.getLabel(MetricSeries.NET_SENTIMENT)
    case MetricSeries.COMMENTS:
    case MetricSeries.LIKES:
    case MetricSeries.SHARES:
    case MetricSeries.VIEWS:
    case MetricSeries.DISLIKES:
    case MetricSeries.SCORE:
      return measureTypeUtil.getLabel(MetricSeries.ENGAGEMENTS)
    default:
      return measureTypeUtil.getLabel(measure, AnalysisType.SW_NEW_SUMMARY)
  }
}

export const formatMetricSeriesType = (metricSeriesType, value) => {
  const percentFormatter = new Intl.NumberFormat(undefined, { style: 'percent' })
  const numberFormatter = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3
  })

  switch (metricSeriesType) {
    case MetricSeries.NET_SENTIMENT:
      return percentFormatter.format(value / 100)
    default:
      return numberFormatter.format(value)
  }
}
